var Monad = /** @class */ (function () {
    function Monad() {
    }
    return Monad;
}());
export { Monad };
//# sourceMappingURL=monad.js.map